import { Text } from '@antv/g';
export function ellipsisIt(el, w, suffix) {
    if (suffix === void 0) { suffix = '...'; }
    var node = el instanceof Text ? el : el.node();
    if (node.nodeName === 'text') {
        var cfg = { wordWrap: true, wordWrapWidth: w, maxLines: 1, textOverflow: suffix };
        node.attr(cfg);
    }
}
//# sourceMappingURL=ellipsis.js.map